import React, { useEffect, useState } from 'react'
import { reportToSentry } from 'utils/reportToSentry'
import builder, { BuilderComponent, BuilderContent } from '@builder.io/react'

function BuilderContentManagement() {
  const [ paymentAuthorizationNoticeContent, setPaymentAuthorizationNoticeContent ] = useState<null | BuilderContent>( null )
  useEffect( () => {
    builder.get( `payment-authorization-notice` )
      .promise()
      .then( ( content: BuilderContent ) => setPaymentAuthorizationNoticeContent( content ) )
      .catch( ( error: Error ) =>
        reportToSentry( new Error ( `there was a error fetching payment auth notice content from builder.io using BuilderContentFetch`, {
          cause: error
        }) ) )
  }, [] )

  if ( !paymentAuthorizationNoticeContent ) return null

  return (
    <div>
      <BuilderComponent model="payment-authorization-notice" content={paymentAuthorizationNoticeContent as any} />
    </div>
  )
}

export default BuilderContentManagement